import { FC, memo, useMemo } from "react";
import { IPastExperienceProps } from "./pastExperience.props";
import {
  AvatarItem,
  CompanyName,
  ContainerItem,
  ContainerPastExperience,
  Divider,
  EndTime,
  FooterItem,
  HeaderItem,
  IDoText,
  Item,
  Job,
  JobBlock,
  JobCanDo,
  LeftItem,
  LinkWebsite,
  StartTime,
  Title,
  TitleBlock,
  WorkDuration,
  WorkDurationBlock,
  WorkDurationValue,
} from "./pastExperience.style";
import {
  PastExperienceIcon,
  WebsiteIcon,
} from "assets/images/profile-preview/index";
import { IEmploymentHistory } from "api/users";
import { handleLongText } from "utils/text";
import { useAppSelector } from "redux/hooks";
import { Avatar } from "antd";

const PastExperience: FC<IPastExperienceProps> = ({ pastExperienceData }) => {
  const data: IEmploymentHistory[] = useMemo(() => {
    return pastExperienceData || [];
  }, [pastExperienceData]);
  const userInfo = useAppSelector((state) => state.auth.user);

  return (
    <ContainerPastExperience>
      <TitleBlock>
        <PastExperienceIcon />
        <Title>Past Experience</Title>
      </TitleBlock>
      <ContainerItem>
        {data.map((item, i: number) => (
          <Item key={i}>
            <HeaderItem>
              <AvatarItem>
                <Avatar
                  shape="circle"
                  size={28}
                  src={userInfo?.profilePicture}
                />
              </AvatarItem>
              <LeftItem>
                <JobBlock>
                  <Job>{item.designation}</Job>
                  <CompanyName>{item.company}</CompanyName>
                </JobBlock>
                <WorkDurationBlock>
                  <WorkDuration>Work duration</WorkDuration>
                  <WorkDurationValue>
                    {item.isCurrentWork ? (
                      <>
                        <StartTime>
                          {new Date(item.startDate).getFullYear()}
                        </StartTime>{" "}
                        - <StartTime>Present</StartTime>
                      </>
                    ) : (
                      <EndTime>
                        {new Date(item.startDate).getFullYear()} -{" "}
                        {new Date(item.endDate).getFullYear()}
                      </EndTime>
                    )}
                  </WorkDurationValue>
                </WorkDurationBlock>
                <WorkDurationBlock>
                  <IDoText>I do</IDoText>
                  <JobCanDo>{item.experienceFromCompany}</JobCanDo>
                </WorkDurationBlock>
              </LeftItem>
            </HeaderItem>
            <Divider />
            <FooterItem>
              <WebsiteIcon />
              {item.companyUrl !== "" && (
                <a href={item.companyUrl} target="_blank" rel="noreferrer">
                  <LinkWebsite>
                    {handleLongText(item.companyUrl, 36)}
                  </LinkWebsite>
                </a>
              )}
            </FooterItem>
          </Item>
        ))}
      </ContainerItem>
    </ContainerPastExperience>
  );
};

export default memo(PastExperience);
